import {
    AppBar,
    Box,
    Toolbar,
    Typography
} from '@mui/material';
import React from 'react';

const SimpleLayout = ({ children, onLogout }) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            {/* Header */}
            <AppBar
                position="static"
                sx={{
                    backgroundColor: 'white',
                    color: '#1e3a8a',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                }}
            >
                <Toolbar
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', md: 'row' },
                        alignItems: { xs: 'center', md: 'center' },
                        justifyContent: { xs: 'center', md: 'flex-start' },
                        textAlign: { xs: 'center', md: 'left' },
                        py: { xs: 1.5, md: 0 },
                        gap: { xs: 1, md: 0 }
                    }}
                >
                    {/* Logo */}
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <img
                            src={process.env.PUBLIC_URL + '/asg-logo.png'}
                            alt="ASG Eye Care"
                            style={{
                                maxHeight: '40px',
                                width: 'auto',
                                objectFit: 'contain'
                            }}
                        />
                    </Box>

                    {/* Spacer pushes title to the far right on desktop */}
                    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'block' } }} />

                    {/* Title at the right corner on desktop */}
                    <Typography variant="h6" component="div" sx={{
                        color: '#1e3a8a',
                        fontWeight: 700,
                        mt: { xs: 1, md: 0 },
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                        textAlign: { xs: 'center', md: 'right' }
                    }}>
                        {(() => {
                            const campData = localStorage.getItem('currentCamp');
                            if (campData) {
                                const camp = JSON.parse(campData);
                                const startDate = new Date(camp.startDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
                                return `${camp.campName} - ${startDate}`;
                            }
                            return `ASG Eye Care Camp - ${new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}`;
                        })()}
                    </Typography>
                </Toolbar>
            </AppBar>

            {/* Main Content */}
            <Box component="main" sx={{ flexGrow: 1 }}>
                {children}
            </Box>
        </Box>
    );
};

export default SimpleLayout;
